const DEFAULT_TRAINING_PORTAL_ENTER_URL =
  'https://dev-training-portal.centrajob.com/training/enter';

/** Builds the external training portal URL with JWT and portal=college (query params are encoded). */
export function buildTrainingPortalEnterUrl(accessToken: string): string {
  const base =
    import.meta.env.VITE_TRAINING_PORTAL_ENTER_URL || DEFAULT_TRAINING_PORTAL_ENTER_URL;
  const url = new URL(base);
  url.searchParams.set('token', accessToken);
  url.searchParams.set('portal', 'college');
  return url.toString();
}
